import { FC, useState } from "react";
import { Box, Button, IconButton, Popover, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { FirstLetterUpperCase } from "../helpers/helpersSearchs";

export const DeleteConfirmButton: FC<{
  onConfirm: () => void;
  t: (arg0: string) => string;
  deleteText: string;
  onSet?: () => void;
  color?: "error" | "primary" | "secondary";
  withText?: boolean;
}> = ({ onConfirm, t, onSet, deleteText, color, withText }) => {
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => {
          setAnchor(e.currentTarget);
          onSet?.();
        }}
        sx={{
          height: "30px",
          width: withText ? "fit-content" : "30px",
          padding: withText ? "4px 8px" : "4px",
          borderRadius: withText ? "4px" : "50%",
        }}
      >
        <DeleteIcon color={color ? color : "inherit"} fontSize="inherit" />
        {withText && (
          <Typography
            variant="body2"
            color={color ? color : "inherit"}
            sx={{ ml: 0.5 }}
          >
            {t("Common_options.Delete")}
          </Typography>
        )}
      </IconButton>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, maxWidth: 220 }}>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            {`${deleteText}`}
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button
              size="small"
              variant="outlined"
              onClick={() => setAnchor(null)}
              sx={{ textTransform: "none" }}
            >
              {t("Common_options.Cancel")}
            </Button>
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ textTransform: "none" }}
              onClick={() => {
                setAnchor(null);
                onConfirm();
              }}
            >
              {FirstLetterUpperCase(t("Common_options.confirm"))}
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};
